module.exports = __webpack_public_path__ + "static/media/platform_with_robust_features_img.f8b2c990.png";